import { useRef } from 'react';
import { useInfiniteNimbuxHotels } from '@frontend/features/hotel-content-manager/queries';
import { useIntersectionObserver } from '@frontend/features/common/hooks/useIntersectionObserver';
import { NimbuxHotelSearch } from '@bandido/shared/interfaces';

const DEFAULT_PAGE_SIZE = 10;

export const useNimbuxHotelsList = ({ pageSize = DEFAULT_PAGE_SIZE, ...filters }: Partial<NimbuxHotelSearch> = {}) => {
  const observerTarget = useRef<HTMLDivElement>(null);

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isError } = useInfiniteNimbuxHotels({
    pageSize,
    ...filters,
  });

  useIntersectionObserver({
    targetRef: observerTarget,
    onIntersect: () => {
      fetchNextPage();
    },
    enabled: !isFetchingNextPage && Boolean(hasNextPage),
  });

  const allHotels = data?.pages?.flatMap((page) => page.items) ?? [];

  const handleEdit = (hotelName: string) => {
    console.log(`Editing hotel: ${hotelName}`);
  };

  return {
    allHotels,
    isLoading,
    isError,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    handleEdit,
    observerTarget,
  };
};
